export const ARCHIVE_RETENTION_UNLIMITED = 0;
export const asRetentionDays = (retentionTime) => {
  if (retentionTime === null || retentionTime === void 0 || retentionTime === "") {
    return null;
  }
  const parsed = Number(retentionTime);
  return Number.isNaN(parsed) ? null : parsed;
};
export const formatArchiveRetentionTime = (retentionTime) => {
  const days = asRetentionDays(retentionTime);
  if (days === null) {
    return "";
  }
  return days === ARCHIVE_RETENTION_UNLIMITED ? "unlimited" : String(days);
};
const inDays = (days) => days === ARCHIVE_RETENTION_UNLIMITED ? "unlimited" : `${days} days`;
export const archiveRetentionSummary = (overrideEnabled, retentionTime, globalRetentionTime) => {
  if (!overrideEnabled) {
    const global = asRetentionDays(globalRetentionTime);
    return global === null ? "Global" : `Global (${inDays(global)})`;
  }
  const days = asRetentionDays(retentionTime);
  if (days === null) {
    return "Global";
  }
  return days === ARCHIVE_RETENTION_UNLIMITED ? "0 days (unlimited)" : inDays(days);
};
const asCarrier = (candidate) => candidate && typeof candidate === "object" ? candidate : null;
const archiveConfigOf = (values) => {
  var _a, _b;
  const dataTiering = asCarrier(values == null ? void 0 : values.data_tiering);
  const legacyRotation = (_a = values == null ? void 0 : values.use_legacy_rotation) != null ? _a : dataTiering === null;
  if (!legacyRotation && dataTiering) {
    return { archiving: (_b = dataTiering.archive_before_deletion) != null ? _b : false, carrier: dataTiering };
  }
  const retentionStrategy = asCarrier(values == null ? void 0 : values.retention_strategy);
  if (legacyRotation && retentionStrategy && "archive_retention_override_enabled" in retentionStrategy) {
    return { archiving: true, carrier: retentionStrategy };
  }
  return { archiving: false, carrier: null };
};
const effectiveRetentionTime = (values, globalRetentionTime) => {
  const { archiving, carrier } = archiveConfigOf(values);
  const override = archiving && (carrier == null ? void 0 : carrier.archive_retention_override_enabled) ? asRetentionDays(carrier.archive_retention_time) : null;
  const days = override != null ? override : globalRetentionTime;
  if (days === null || days === ARCHIVE_RETENTION_UNLIMITED) {
    return null;
  }
  return days;
};
const archiveRetentionInputs = (values) => {
  var _a;
  const { archiving, carrier } = archiveConfigOf(values);
  const override = archiving && ((_a = carrier == null ? void 0 : carrier.archive_retention_override_enabled) != null ? _a : false);
  return {
    archiving,
    override,
    retentionTime: override ? asRetentionDays(carrier == null ? void 0 : carrier.archive_retention_time) : null
  };
};
export const archiveRetentionChanged = (initialValues, values) => {
  const before = archiveRetentionInputs(initialValues);
  const after = archiveRetentionInputs(values);
  return before.archiving !== after.archiving || before.override !== after.override || before.retentionTime !== after.retentionTime;
};
export const archiveRetentionShortenedBy = (initialValues, values, globalRetentionTime) => {
  const before = effectiveRetentionTime(initialValues, globalRetentionTime);
  const after = effectiveRetentionTime(values, globalRetentionTime);
  if (after === null) {
    return null;
  }
  if (before !== null && after >= before) {
    return null;
  }
  return { from: before, to: after };
};
